import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll to the top on every route change.
 * Mount once, just inside <BrowserRouter>, before <Routes>.
 *
 * Behaviour:
 *   - Triggers on `pathname` change (does NOT reset when only query/hash changes).
 *   - Skips reset when navigating to an anchor (`#section`) — let the browser handle it.
 *   - Uses instant scroll (no smooth animation) to avoid jarring mid-scroll on navigation.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
